import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'Roberto G.',
  location: 'CDMX',
  age: '46 años',
  headline: 'Bajé 4 kilos de barriga y recuperé mi enfoque',
  text: 'A mis 46 años creía que mi energía nunca volvería. Seguí el protocolo de 15 minutos y en la segunda semana ya no necesitaba café en la tarde. Mi esposa es la más feliz con el cambio.',
  result: '-4kg de grasa y energía 2x en 21 días.'
}, {
  name: 'Andrés M.',
  location: 'Bogotá',
  age: 'Abogado',
  headline: 'Adiós a la neblina mental',
  text: 'Soy abogado y el estrés me estaba matando. Código Alfa me enseñó los suplementos básicos que me faltaban. Ahora rindo más en el despacho que mis colegas de 30 años.',
  result: 'Enfoque total y 100% de potencia matutina recuperada.'
}, {
  name: 'Carlos S.',
  location: 'Buenos Aires',
  age: '52 años',
  headline: 'Por fin algo que entiende nuestra comida',
  text: "Odiaba las dietas de 'pollo y brócoli'. Con este guía aprendí que puedo comer carne y grasas ricas y aun así mejorar mis hormonas. Espectacular.",
  result: 'Niveles de Testo Total subieron de 340 a 580 ng/dL.'
}];
export function TestimonialsSection() {
  return <section className="py-24 px-4 bg-[#111827] border-y border-[#c9a84c]/10" data-id="element-225">
      <div className="max-w-6xl mx-auto" data-id="element-226">
        <FadeIn data-id="element-227">
          <div className="text-center mb-16" data-id="element-228">
            <h2 className="text-3xl md:text-5xl font-bold text-[#f5f5f5] mb-4" data-id="element-229">
              Hombres Reales.{' '}
              <span className="text-[#c9a84c]" data-id="element-230">Resultados Reales.</span>
            </h2>
            <p className="text-xl text-[#9ca3af]" data-id="element-231">
              Lo que dicen los miembros de la comunidad Código Alfa 40+
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-232">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-233">
              <div className="bg-[#0a0e1a] border border-[#c9a84c]/20 p-8 rounded-2xl h-full flex flex-col relative" data-id="element-234">
                <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-[#c9a84c]/10" data-id="element-235" />

                <div className="flex gap-1 mb-4" data-id="element-236">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#c9a84c] text-[#c9a84c]" data-id="element-237" />)}
                </div>

                <h3 className="text-xl font-bold text-[#f5f5f5] mb-4" data-id="element-238">
                  "{testimonial.headline}"
                </h3>

                <p className="text-[#9ca3af] mb-6 flex-grow italic" data-id="element-239">
                  "{testimonial.text}"
                </p>

                <div className="mt-auto pt-6 border-t border-[#c9a84c]/10" data-id="element-240">
                  <div className="flex items-center justify-between mb-2" data-id="element-241">
                    <span className="font-bold text-[#f5f5f5]" data-id="element-242">
                      {testimonial.name}
                    </span>
                    <span className="text-sm text-[#9ca3af]" data-id="element-243">
                      {testimonial.location}
                    </span>
                  </div>
                  <div className="bg-[#111827] text-[#c9a84c] text-sm py-2 px-3 rounded-md border border-[#c9a84c]/20" data-id="element-244">
                    <span className="font-semibold" data-id="element-245">Resultado:</span>{' '}
                    {testimonial.result}
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}